import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import LogoutModal from './LogoutModal'
import { WebLogoMain } from '../utils/Images'

const Header = () => {
    const [openLogoutModal, setOpenLogoutModal] = useState(false)
    const navigate = useNavigate();
    const pathname = window && window.location.pathname;

    const handleOpenLogoutModal = () => {
        setOpenLogoutModal(true)
    }
    const handleCancelLogoutModal = () => {
        setOpenLogoutModal(false)
    }

    return (
        <HeaderWrapper>
            {openLogoutModal && <LogoutModal openLogoutModal={openLogoutModal} handleCancelLogoutModal={handleCancelLogoutModal} />}
            <div className='main-div'>
                <div className='logo-div'>
                    <img src={WebLogoMain} width={34} height={34} alt="" onClick={() =>  navigate("/landing/home")}/>
                </div>
                {pathname == "/landing/manage-subscription" ? <div className='right-side-sub'>
                    <h1 onClick={() => navigate("/landing/home")} style={{ color: pathname == "/landing/home" ? "#0DA982" : "#000" }}>Home</h1>
                    <h1 onClick={() => navigate("/landing/manage-subscription")} style={{ color: pathname == "/landing/manage-subscription" ? "#0DA982" : "#000" }}>Manage Subscription</h1>
                    <h1 onClick={() => handleOpenLogoutModal()}>Logout</h1>
                </div> : <div className='right-side'>
                    <h1 className='heading' onClick={() => navigate("/landing/home")} style={{ color: pathname == "/landing/home" ? "#0DA982" : "#fff" }}>Home</h1>
                    <h1 onClick={() => navigate("/landing/manage-subscription")} style={{ color: pathname == "/landing/manage-subscription" ? "#0DA982" : "#fff" }}>Manage Subscription</h1>
                    <h1 onClick={() => handleOpenLogoutModal()}>Logout</h1>
                </div>}

            </div>
        </HeaderWrapper>
    )
}

export default Header

const HeaderWrapper = styled.div`
    position:absolute;
    width:100%;
    z-index:1;
    top:0px;

    @media (max-width: 700px){
        display:none;
    }

    .main-div{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:space-between;
        padding: 34px 66px 0px 69px;
        .logo-div{
            img{
                cursor: pointer
            }
        }
        .right-side{
            display:flex;
            align-items:center;
            gap:57px;
            h1{
                color:#fff;
                font-weight:700;
                font-size:15px;
                cursor:pointer;
            }
        }
        .right-side-sub{
            display:flex;
            align-items:center;
            gap:57px;
            h1{
                color:#000;
                font-weight:700;
                font-size:15px;
                cursor:pointer;
            }
        }
    }
`;